import { makeStyles } from '@material-ui/core'
import React, { ReactNode, useState } from 'react'
import AdminNavBar from './AdminNavBar'
import { AdminRoutes } from './AdminRoutes'
import { Decoration } from './Decoration'
import TopBar from './TopBar'

interface RouteProps {
  title: string
  href?: string
  icon?: ReactNode
  component?: ReactNode
}

export function AdminLayout(): JSX.Element {
  const classes = useStyles()
  const [isMobileNavOpen, setMobileNavOpen] = useState<boolean>()

  return (
    <>
      <Decoration />
      <div className={classes.root}>
        <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} className={classes.topbar} />

        <AdminNavBar onMobileClose={() => setMobileNavOpen(false)} openMobile={isMobileNavOpen} />

        <div className={classes.wrapper}>
          <div className={classes.contentContainer}>
            <div className={classes.content}>
              <AdminRoutes />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    // backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
  },
  topbar: {
    backgroundColor: theme.palette.primary.main,
    // paddingLeft: 240,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 245,
    },
  },
  // topbarMobile: { paddingLeft: 0 },
  wrapper: {
    zIndex: 10,
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256,
    },
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto',
  },
}))
